import React from 'react';
import { motion } from 'framer-motion';
import { ExternalLink } from 'lucide-react';
import './DeliverySection.css';

const DeliverySection = () => {
    const uberEatsUrl = "https://www.ubereats.com/fr/store/sugar-hut/CNuUAKhPR0KbiSD4W6PY7Q?srsltid=AfmBOoqWk0lJixJ7zaiQfquoJJOUXec6E9phRb2SpreBMpwNcm4OzC8H";

    return (
        <section className="delivery-section">
            <div className="floating-elements">
                <div className="blob blob-1" />
                <div className="blob blob-2" />
            </div>

            <div className="container delivery-grid">
                <motion.div
                    initial={{ opacity: 0, x: -50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                    className="delivery-content"
                >
                    <span className="delivery-tag">Livraison Rapide</span>
                    <h2 className="delivery-title">Le Sugar Hut, directement chez vous.</h2>
                    <p className="delivery-text">
                        Pas envie de sortir ? On s'occupe de tout. Retrouvez vos burgers préférés en quelques clics sur Uber Eats et faites-vous livrer en moins de 30 minutes.
                    </p>
                    <a
                        href={uberEatsUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="uber-button"
                    >
                        <span>Commander sur <span className="uber-icon">Uber Eats</span></span>
                        <ExternalLink size={20} />
                    </a>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, scale: 0.8, rotate: -5 }}
                    whileInView={{ opacity: 1, scale: 1, rotate: 2 }}
                    viewport={{ once: true }}
                    transition={{ duration: 1, type: "spring" }}
                    className="delivery-image-container"
                >
                    <img
                        src="/delivery.png"
                        alt="Uber Eats Delivery Sugar Hut"
                        className="delivery-img"
                    />
                </motion.div>
            </div>
        </section>
    );
};

export default DeliverySection;
